import { render } from "./EvidencePieGraph.vue?vue&type=template&id=b2575870&ts=true"
import script from "./EvidencePieGraph.vue?vue&type=script&lang=ts"
export * from "./EvidencePieGraph.vue?vue&type=script&lang=ts"

import "./EvidencePieGraph.vue?vue&type=style&index=0&id=b2575870&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__